import { Autocomplete, TextField } from '@mui/material';
import { useController } from 'react-hook-form';
import { useState } from 'react';
import { isNominalId } from '@/utils';

export function NominalIdsController({ name, control, label }) {
  const [inputValue, setInputValue] = useState('');
  const [inputError, setInputError] = useState(null);

  const {
    field: { value, onChange, ref },
    fieldState: { error, invalid },
  } = useController({
    name,
    control,
  });

  function renderInput(params) {
    return (
      <TextField
        inputRef={ref}
        label={label}
        error={invalid || !!inputError}
        helperText={error?.message ?? inputError}
        {...params}
      />
    );
  }

  async function handleChange(_, selections) {
    if (selections.length > (value ?? []).length) {
      const newItem = selections[selections.length - 1];
      if (typeof newItem === 'string') {
        const result = await isNominalId(newItem);
        if (result !== true) {
          setInputError(result);
          return;
        }
      }
    }

    setInputError(null);
    setInputValue('');
    onChange(selections.map((selection) => selection.value ?? selection));
  }

  function handleInputChange(_, value, reason) {
    if (reason === 'input' || reason === 'clear') {
      setInputError(null);
      setInputValue(value);
    }
  }

  return (
    <Autocomplete
      value={value ?? []}
      inputValue={inputValue}
      size="small"
      fullWidth
      multiple
      freeSolo
      onChange={handleChange}
      onInputChange={handleInputChange}
      options={[]}
      isOptionEqualToValue={() => false}
      renderInput={renderInput}
    />
  );
}
